import { todayInWarsaw } from '../events/calendar';
import { monthLabel, shiftMonth } from '../finance/format';

/**
 * The period of "Wyceny" (owner 2026-10-24 00:26: "wyswietlenie po zakresie dat. domyslnie tylko biezacy miesiac"):
 * Warsaw days `from`–`to`, both inclusive, as the API takes them. It lives in the address (`od`, `do`), so it survives a
 * reload and "Wstecz"; without them (every new visit) it is the current month.
 */
export type ListRange = { from: string; to: string };

const DAY = /^\d{4}-\d{2}-\d{2}$/;
const isDay = (s: string | null): s is string => !!s && DAY.test(s) && !Number.isNaN(Date.parse(`${s}T00:00:00Z`)) && new Date(`${s}T00:00:00Z`).toISOString().startsWith(s);

/** First and last day of a month ('YYYY-MM'). */
export function monthDays(month: string): ListRange {
  const [y, m] = month.split('-').map(Number) as [number, number];
  return { from: `${month}-01`, to: new Date(Date.UTC(y, m, 0)).toISOString().slice(0, 10) };
}

/** The period the address asks for; the current month when it asks for none (or for nonsense). */
export function rangeFromParams(params: URLSearchParams, today = todayInWarsaw()): ListRange {
  const from = params.get('od');
  const to = params.get('do');
  if (isDay(from) && isDay(to) && from <= to) return { from, to };
  return monthDays(today.slice(0, 7));
}

/** The month the period is one whole month of, else null. */
export function wholeMonth(r: ListRange): string | null {
  const month = r.from.slice(0, 7);
  const days = monthDays(month);
  return days.from === r.from && days.to === r.to ? month : null;
}

/** "Poprzedni miesiąc" / "Następny miesiąc": the month before / after the one the period starts in. */
export function shiftRange(r: ListRange, by: number): ListRange {
  return monthDays(shiftMonth(r.from.slice(0, 7), by));
}

const short = (day: string) => `${day.slice(8, 10)}.${day.slice(5, 7)}.${day.slice(0, 4)}`;
/** "listopad 2026" for a whole month, else "03.11.2026 – 20.11.2026". */
export function rangeLabel(r: ListRange): string {
  const month = wholeMonth(r);
  return month ? monthLabel(month) : r.from === r.to ? short(r.from) : `${short(r.from)} – ${short(r.to)}`;
}
